import { getDefaultHeader } from '../../services/serviceAPIHelper';
export const generateTokenService = async function (username, password) {
    const url = process.env.REACT_APP_API_URL_V2 + 'backoffice/generatetoken';
    const dto = {
        username: username,
        password: password
    };

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(dto),
        headers: getDefaultHeader(true)
    });
    if (!response.ok) {
        let body = await response.json();
        //throw new Error(body.message);
        return Promise.reject(body);
    }
    return response.json();
};


// WEBPACK FOOTER //
// ./src/components/BackOffice/tokenGeneratorService.js